import { render, staticRenderFns } from "./VrstaTeme2Base.vue?vue&type=template&id=0b5c55fe&scoped=true&"
import script from "./VrstaTeme2Base.vue?vue&type=script&lang=js&"
export * from "./VrstaTeme2Base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c55fe",
  null
  
)

export default component.exports